<div class="custom-snackbar">
  <mat-icon class="check-icon" fontIcon="done"></mat-icon>
  <div class="content">
    <div class="fw-700">{{ data.title }}</div>
    <span>{{ data.message }}</span>
  </div>
  <mat-icon (click)="closeSnackBar()" class="close-icon" fontIcon="close"></mat-icon>
</div>
